import { injectReducer } from '../../store/reducers'
import { injectSaga } from '../../store/sagas'
import { getUserData } from '../../utils/token'
import AppConfig from '../../utils/config'
import checkRole from '../../utils/userRoles'

export default store => ({
  path: 'news/updateCategory/(:id)',
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure(
      [],
      require => {
        /*  Webpack - use require callback to define
          dependencies for bundling   */
        const NewsUpdateCategory = require('./containers/NewsUpdateCategoryContainer')
          .default
        const reducer = require('./modules/reducer').default
        const saga = require('./modules/saga').default

        /*  Add the reducer to the store on key 'counter'  */
        injectReducer(store, { key: 'newsUpdateCategory', reducer })
        injectSaga(store, { key: 'newsUpdateCategory', saga })

        /*  Return getComponent   */
        cb(null, NewsUpdateCategory)

        /* Webpack named bundle   */
      },
      'news/updateCategory'
    )
  },
  onEnter: ({ location }, replace) => {
    const user = getUserData()

    if (!user) {
      const { pathname, search } = location
      replace(`login?returnUrl=${pathname}${search}`)
    }

    const { authentication } = store.getState()

    if (
      !authentication.permissions ||
      authentication.permissions.length === 0 ||
      checkRole(authentication.permissions, AppConfig.permissions.ManageCms) ===
        false
    ) {
      replace(`/404`)
    }
  }
})



// WEBPACK FOOTER //
// ./src/routes/NewsUpdateCategory/index.js